import API from 'utils/api';
import { onError } from 'utils/handlers';
import { formatReceived } from 'utils/formatValues';
import { postComentarioDeTramite } from './comentariosDeTramites';

export const baseURI = 'tramites/historiales-de-tramites/';

/**
 * GET Historial de Tramite
 * param {object} params
 * @returns {Promise<object>}
 */
export const getHistorialDeTramite = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Historial de Tramite
  * @param {object} values
  * @param {string?} values.comentario
  * @param {boolean} values.es_comentario_interno
  * @param {number} values.tramite
  * @param {number} values.paso
  * @param {number} values.paso_a_mandar
  * @param {File[]} values.archivos
 * @returns {Promise<object|boolean>}
 */
export const postHistorialDeTramite = async ({
  comentario,
  es_comentario_interno = false,
  tramite,
  archivos = [],
  ...values
}) => {
  try {
    const valuesComentario = {
      comentario,
      es_comentario_interno,
      tramite,
      archivos,
    };
    const _comentario = comentario ? await postComentarioDeTramite(valuesComentario) : null;
    if (comentario && !_comentario) {
      onError({ data: { detail: 'Ha ocurrido un error intentelo de nuevo' } });
      return false;
    }
    const response = await API.post(baseURI, { ...values, comentario: _comentario?.id, tramite });
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
